import { render, staticRenderFns } from "./CopyProducts.vue?vue&type=template&id=bfd6fade&scoped=true"
import script from "./CopyProducts.vue?vue&type=script&lang=js"
export * from "./CopyProducts.vue?vue&type=script&lang=js"
import style0 from "./CopyProducts.vue?vue&type=style&index=0&id=bfd6fade&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfd6fade",
  null
  
)

export default component.exports